import MetadataDefinitions from '@/shared/types/metadata/metadataDefinitions.type';

const getInventoryItemsTableColumns = (definitions: MetadataDefinitions[]) => {
  const tableColumnsList = definitions
    .filter((definition) => definition.level_constraint === 'ATOM')
    .map((item) => item.metadata_key);

  const tableRequiredColumns = definitions
    .filter(
      (definition) =>
        definition.level_constraint === 'ATOM' &&
        definition.required_level === 'REQUIRED',
    )
    .map((item) => item.metadata_key);

  return {
    tableColumnsList,
    tableRequiredColumns: [
      'inventory_atom_id',
      ...tableRequiredColumns,
      'actions',
    ],
  };
};

export default getInventoryItemsTableColumns;
